// extracted by mini-css-extract-plugin
export default {"modalContainer":"Form-module--modalContainer--Kn+lc","formContainer":"Form-module--formContainer--GaOpF"};